import * as React from "react";
import styles from "./styles.module.scss";

interface ConfirmationButtonContainerProps {
  children: React.ReactNode | React.ReactNode[] | string | string[];
}

export const ConfirmationButtonContainer = ({
  children,
}: ConfirmationButtonContainerProps) => (
  <section className={styles.confirmationButtonContainer}>{children}</section>
);
